{
  "actionSelectLabel": "Azione",
  "createScheduleHelpContent": "Quick Scheduler è una funzionalità che consente di creare una programmazione per accendere una pompa o una valvola a un orario specifico o per una durata specifica.\n\nLe programmazioni possono essere impostate per essere eseguite una volta o per essere ripetute in giorni specifici della settimana. Per programmare una singola esecuzione, seleziona \"Do Once\"; altrimenti, seleziona \"Repeat\".\n\nNota che questa funzionalità è pensata per essere utilizzata con pompe e valvole che possono essere accese da FarmHQ. L'utilizzo di questa funzionalità con pompe o altri tipi di apparecchiature che si possono spegnere da sole potrebbe avere conseguenze indesiderate.",
  "createScheduleHelpTitle": "Informazioni su Quick Scheduler",
  "dayPickerLabel": "Giorno",
  "delayedShutdownTitle": "Arresto ritardato",
  "deviceSelectLabel": "Dispositivo",
  "deviceSelectPlaceholder": "(Scegli dispositivo)",
  "durationHoursLabel": "Ore",
  "durationMinutesLabel": "Minuti",
  "errorMessages": {
    "DURATION_BELOW_MINIMUM": "La durata deve essere maggiore di 0 minuti.",
    "EXECUTION_TIME_IN_PAST": "L'ora di esecuzione non può essere nel passato.",
    "NO_COMPATIBLE_DEVICES": "Nessun dispositivo compatibile trovato,",
    "NO_REPEATING_DAYS": "Il programma deve ripetersi almeno un giorno.",
    "SCHEDULE_END_BEFORE_START": "La fine della programmazione è prima dell'inizio.",
    "SCHEDULE_END_IN_PAST": "La fine della programmazione non può essere nel passato.",
    "SCHEDULE_START_IN_PAST": "L'inizio della pianificazione non può essere nel passato.",
    "SHUTDOWN_IN_PAST": "L'arresto deve avvenire in futuro"
  },
  "executeAt": "Eseguire a",
  "executeAtWithTimezone": "Esegui alle ({{timezone}})",
  "executionDay": "Giorno dell'esecuzione",
  "frequencyLabel": "Frequenza",
  "linkToCreateSchedule": "Nuovo programma",
  "linkToDelayedShutdown": "Arresto ritardato",
  "next": "Prossimo",
  "nextDay": "Giorno successivo",
  "back": "Indietro",
  "cancel": "Cancellare",
  "noCompatibleDevices": "Nessun dispositivo compatibile trovato,",
  "quickSchedulerTitle": "Pianificatore rapido",
  "repeatOnDays": "Ripeti nei giorni",
  "scheduleEndLabel": "Fine programma",
  "scheduleFrequencyTypes": {
    "doOnce": "Fai una volta",
    "repeat": "Ripetere"
  },
  "schedulePumpingSession": "Pianificare una sessione di pompaggio",
  "scheduleStartLabel": "Inizio programmato",
  "shutdownPumpAt": "Spegnimento pompa a",
  "submit": "Invia",
  "timePickerLabel": "Tempo",
  "turnOfThePumpForWithVal": "Spegnere la pompa per {{val}}",
  "turnOffThePumpAfter": "Spegnere la pompa dopo",
  "turnOnThePumpAt": "Accendere la pompa a",
  "turnOnThePumpAtWithTimezone": "Accendere la pompa alle ({{timezone}})",
  "usageWarning": "Questa funzionalità è pensata per essere utilizzata con pompe e valvole che possono essere attivate da FarmHQ. L'utilizzo di questa funzionalità con pompe di solo spegnimento o altri tipi di apparecchiature potrebbe avere conseguenze indesiderate."
}
